import axios from "axios";
import { setupCache } from "axios-cache-adapter";

const cache = setupCache({
  maxAge: 15 * 60 * 1000,
});

const api = axios.create({
  adapter: cache.adapter,
});

/**
 * Call get
 * @param {*} url
 * @param {*} params
 */

export const CallGet = async (url, params, headers = {}) =>
  new Promise(resolve => {
    api
      .get(`${url}`, {
        params,
        headers
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        resolve(err);
      });
  });
